import { Component, Vue } from 'vue-property-decorator';
import { CustomNotification } from '@/models/custom-notification.model';
import { namespace } from 'vuex-class';

const Notification = namespace('notification');

@Component({
})
export default class PublicView extends Vue {

    @Notification.State('notifications') public notifications: CustomNotification[];
    @Notification.Action('removeNotification') private removeNotification: any;

    public menuIsOpen: boolean = false;
    private markedForRemoval: string[] = [];

    public updated() {
        this.notifications.forEach((notification) => {
            if (!this.markedForRemoval.includes(notification.uuid)) {
                this.markedForRemoval.push(notification.uuid);
                setTimeout(() => {
                    this.removeNotification(notification.uuid);
                }, 5000);
            }
        });
    }

    public getCssClasses(notification: CustomNotification): string[] {
        const cssClasses = ['alert', 'mb-2', 'mt-0', 'mr-2'];

        switch (notification.type) {
            case ('ERROR'):
                cssClasses.push('alert-danger');
                break;
            case ('WARNING'):
                cssClasses.push('alert-warning');
                break;
            default:
                cssClasses.push('alert-success');
        }

        return cssClasses;
    }
}
